import { useState, useEffect, useRef } from "react";
import { verifyOtp, resendOtp, clearPending2faToken } from "./authService";
import useBootstrapCSS from "../../hooks/useBootstrapCSS";
import codLogo from "./CoD-Logo.png";
import "./login.css";

const EnterOtp = () => {
    useBootstrapCSS();
    const [otp, setOtp] = useState("");
    const [message, setMessage] = useState({ text: "", type: "" });
    const [isVerifying, setIsVerifying] = useState(false);
    const [isResending, setIsResending] = useState(false);
    const otpInputRef = useRef(null);

    useEffect(() => {
        otpInputRef.current?.focus();
    }, []);

    const showMessage = (text, type) => {
        setMessage({ text, type });
    };

    const handleVerify = async () => {
        const trimmedOtp = otp.trim();

        if (!trimmedOtp) {
            showMessage("Please enter the OTP", "fail");
            return;
        }

        if (trimmedOtp.length !== 6) {
            showMessage("OTP must be 6 digits", "fail");
            return;
        }

        setIsVerifying(true);
        setMessage({ text: "", type: "" });

        try {
            const result = await verifyOtp(trimmedOtp);
            if (result.success) {
                showMessage("OTP verified successfully! Redirecting...", "success");
                clearPending2faToken();
                if (result.token) {
                    localStorage.setItem("token", result.token);
                    if (result.refreshToken) localStorage.setItem("refreshToken", result.refreshToken);
                }
                if (result.redirect) {
                    setTimeout(() => {
                        window.location.href = result.redirect;
                    }, 1000);
                } else {
                    setTimeout(() => { window.location.href = "/dashboard"; }, 1000);
                }
            } else {
                showMessage(result.error || "Verification failed", "fail");
                setIsVerifying(false);
            }
        } catch (error) {
            showMessage(error.message || "Verification failed", "fail");
            setIsVerifying(false);
            setOtp("");
            otpInputRef.current?.focus();
        }
    };

    const handleResend = async () => {
        setIsResending(true);
        setMessage({ text: "", type: "" });

        try {
            const result = await resendOtp();
            if (result.success) {
                showMessage(result.message || "OTP resent successfully!", "success");
            } else {
                showMessage(result.error || "Failed to resend OTP", "fail");
            }
        } catch (error) {
            showMessage(error.message || "Failed to resend OTP", "fail");
        }

        setIsResending(false);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            handleVerify();
        }
    };

    return (
        <section className="login-page">
            <div className="container-fluid">
                <div className="row align-items-center h-100">
                    <div className="col-md-6 col-sm-12 px-5 left-graphic">
                        <img src={codLogo} className="img-fluid" alt="CoD Logo" />
                    </div>

                    <div className="col-md-6 col-sm-12 px-5 form-outer h-100 align-items-center d-flex flex-column justify-content-center">
                        <form className="initial-form" onSubmit={(e) => e.preventDefault()}>
                            <h3 className="h3 mb-3">Two-Factor Authentication</h3>

                            {message.text && (
                                <div className={`alert ${message.type === "success" ? "alert-success" : "alert-danger"} mb-20`}>
                                    {message.text}
                                </div>
                            )}

                            <div className="form-group mb-20">
                                <label htmlFor="otpInput">OTP</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="otpInput"
                                    placeholder="Enter OTP"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value)}
                                    onKeyPress={handleKeyPress}
                                    ref={otpInputRef}
                                    maxLength={6}
                                    required
                                />
                            </div>

                            <div className="d-flex gap-3">
                                <button
                                    type="button"
                                    className="w-50 btn btn-primary mb-20"
                                    onClick={handleVerify}
                                    disabled={isVerifying}
                                >
                                    {isVerifying ? "Verifying..." : "Verify OTP"}
                                </button>
                                <button
                                    type="button"
                                    className="w-50 btn btn-secondary mb-20"
                                    onClick={handleResend}
                                    disabled={isResending}
                                >
                                    {isResending ? "Sending..." : "Resend OTP"}
                                </button>
                            </div>
                        </form>
                        <div className="form-footer">
                            <p>Copyright &copy; {new Date().getFullYear()} Compliance on Demand. All Rights Are Reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EnterOtp;
